import { GAME_SYMBOL_MARVEL_RIVALS } from "@/game-marvel-rivals/definition-symbol.mjs";
import { seoRoutes } from "@/game-marvel-rivals/routes-seo.mjs";
import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchTierlist = lazyFn(
  () => import("@/game-marvel-rivals/fetches/tierlist.mjs"),
);
const fetchPatchNotes = lazyFn(
  () => import("@/game-marvel-rivals/fetches/patch-notes.mjs"),
);
const fetchMaps = lazyFn(() => import("@/game-marvel-rivals/fetches/maps.mjs"));
const fetchArticle = lazyFn(
  () => import("@/shared/fetch-contentful-article.mjs"),
);
const fetchArticles = lazyFn(
  () => import("@/shared/fetch-contentful-articles.mjs"),
);
const fetchMatch = lazyFn(
  () => import("@/game-marvel-rivals/fetches/match-page.mjs"),
);
const fetchProfile = lazyFn(
  () => import("@/game-marvel-rivals/fetches/profile-page.mjs"),
);

const routes: BaseRoute[] = [
  {
    path: pathRegExp("/marvel-rivals/profile/:id/:platform?"),
    component: "game-marvel-rivals/Profile.tsx",
    fetchData: fetchProfile,
  },
  {
    path: pathRegExp("/marvel-rivals/match/:matchId/:playerId/:platform?"),
    component: "game-marvel-rivals/Match.tsx",
    fetchData: fetchMatch,
  },
  {
    path: "/marvel-rivals/heroes",
    component: "game-marvel-rivals/Heroes.tsx",
    fetchData: fetchTierlist,
  },
  {
    path: "/marvel-rivals/tierlist",
    component: "game-marvel-rivals/Tierlist.tsx",
    fetchData: fetchTierlist,
  },
  {
    path: "/marvel-rivals/overlays",
    component: "game-marvel-rivals/Overlays.tsx",
  },
  {
    path: "/marvel-rivals/release-date",
    redirect: "/marvel-rivals/article/1MEGe0XfEG1YMPT4M3yTKm",
    fetchData: fetchPatchNotes,
    component: {
      default: () => null,
      meta: () => ({
        title: ["", ""],
        description: ["", ""],
      }),
    },
  },
  {
    path: "/marvel-rivals/patch-notes",
    component: "game-marvel-rivals/PatchNotes.tsx",
    fetchData: fetchPatchNotes,
  },
  {
    path: "/marvel-rivals/maps",
    component: "game-marvel-rivals/Maps.tsx",
    fetchData: fetchMaps,
  },
  {
    path: "/marvel-rivals/guides",
    component: "shared/Articles.tsx",
    async fetchData() {
      await fetchArticles(GAME_SYMBOL_MARVEL_RIVALS);
    },
  },
  {
    path: pathRegExp("/marvel-rivals/article/:id"),
    component: "game-marvel-rivals/Article.tsx",
    fetchData: fetchArticle,
  },
  ...seoRoutes,
];

routes.push({
  [catchAllRoutes]: routes,
});

export default routes;
